export function createTrainingExaminationInternRecordTableFields (vm) {
  return [
    {key: 'id', prop: 'id', label: '答卷ID'},
    {key: 'training_exam_id', prop: 'training_exam_id', label: '考试ID'},
    {key: 'admin_id', prop: 'admin_id', label: '实习生ID'},
    {key: 'user_name', prop: 'user_name', label: '真实姓名', showOverflowTooltip: true},
    {key: 'submitted_at', prop: 'submitted_at', label: '提交时间'},
    {key: 'examination_duration_text', prop: 'examination_duration_text', label: '用时'},
    {key: 'open_book_exam_text', prop: 'open_book_exam_text', label: '是否开卷'},
    {
      key: 'score_text',
      label: '得分',
      prop: 'score_text',
    },
    {
      key: 'examination_status',
      prop: 'examination_status',
      label: '状态',
    },
  ]
}



// WEBPACK FOOTER //
// ./src/views/training/training-exam-intern-record-table.fields.js